import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {StatusRequest} from '../../../domain/alerts/status-request.model';
import {StatusChange} from '../../../domain/alerts/status-change.enum';
import {Publisher} from '../../../../../shared/domain/publisher.model';

@Component({
  selector: 'cm-widget-status-settings-dialog',
  template: `
    <h1 mat-dialog-title>Widget settings</h1>
    <div mat-dialog-content>
      <div class="d-flex">
        <div class="col">
          <mat-form-field>
            <input matInput type="text" placeholder="Active to inactive"
                   [(ngModel)]="activeToInactiveDays"/>
            <span matSuffix>days</span>
          </mat-form-field>
          <!--<mat-form-field>-->
            <!--<input matInput type="text" placeholder="Ready status"-->
                   <!--[(ngModel)]="draftToReadyDays"/>-->
            <!--<span matSuffix>days</span>-->
          <!--</mat-form-field>-->
          <mat-form-field>
            <input matInput type="text" placeholder="Ready to active"
                   [(ngModel)]="readyToActiveDays"/>
            <span matSuffix>days</span>
          </mat-form-field>
        </div>
        <div class="col">
          <cm-publisher-multiselect-search
            [selectedPublisherIds]="settings.filter?.publisherIds"
            (selectionChange)="onPublisherSelected($event)"></cm-publisher-multiselect-search>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end">
      <button mat-button (click)="save()">Save</button>
      <button mat-button color="warn" mat-dialog-close cdkFocusInitial>Cancel</button>
    </div>

  `,
})
export class WidgetAdUnitStatusChangeSettingsDialogComponent {

  settings: StatusRequest;

  activeToInactiveDays: number;
  draftToReadyDays: number;
  readyToActiveDays: number;

  constructor(public dialogRef: MatDialogRef<WidgetAdUnitStatusChangeSettingsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.settings = data.settings ? JSON.parse(JSON.stringify(data.settings)) : new StatusRequest();
    this.unpack();
  }

  onPublisherSelected(publishers: Publisher[]) {
    this.settings.filter.publisherIds = publishers.map(p => p.id);
  }

  save() {
    this.settings.statusChanges = {};
    if (this.activeToInactiveDays) {
      this.settings.statusChanges[StatusChange.ACTIVE_TO_INACTIVE] = this.activeToInactiveDays;
    }
    if (this.readyToActiveDays) {
      this.settings.statusChanges[StatusChange.READY_TO_ACTIVE] = this.readyToActiveDays;
    }
    if (this.draftToReadyDays) {
      this.settings.statusChanges[StatusChange.DRAFT_TO_READY] = this.draftToReadyDays;
    }
    this.dialogRef.close(this.settings);
  }

  private unpack() {
    this.activeToInactiveDays = this.settings.statusChanges ? this.settings.statusChanges[StatusChange.ACTIVE_TO_INACTIVE] : null;
    this.draftToReadyDays = this.settings.statusChanges ? this.settings.statusChanges[StatusChange.DRAFT_TO_READY] : null;
    this.readyToActiveDays = this.settings.statusChanges ? this.settings.statusChanges[StatusChange.READY_TO_ACTIVE] : null;
  }


}

